import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import AdminPanel from '@/components/Admin/AdminPanel';

export default function AdminPage() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const goToMain = () => {
    navigate('/');
  };

  return (
    <div className="h-screen w-screen flex flex-col bg-background">
      {/* Header */}
      <div className="h-12 bg-card border-b flex items-center px-4 shrink-0 gap-4">
        <h1 className="text-lg font-semibold text-primary">Uncommonable - Admin Panel</h1>

        <div className="ml-auto flex items-center gap-3">
          <button
            onClick={goToMain}
            className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Back to IDE
          </button>
          <button
            onClick={handleSignOut}
            className="px-3 py-1.5 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Admin Content */}
      <div className="flex-1 overflow-hidden">
        <AdminPanel />
      </div>

      {/* Status Bar */}
      <div className="h-6 bg-primary text-primary-foreground text-xs flex items-center px-4 shrink-0">
        <span>Admin Mode</span>
        <span className="ml-auto">Uncommonable v2.0</span>
      </div>
    </div>
  );
}
